// Tracking: a middleware for GTM/GA

function track(event = '', eventData = {}) {
  const dataLayerData = eventData;

  if (typeof window.dataLayer === 'undefined' || !window.dataLayer) {
    return;
  }

  dataLayerData.event = event;
  window.dataLayer.push(dataLayerData);
}

function trackCustomEvent(eventData = {}) {
  track('CustomEvent', eventData);
}

// Track GA page view
function trackPageView() {
  if (typeof (window.ga) !== 'undefined' && window.ga) {
    window.ga('send', 'pageview', {
      page: window.location.pathname,
      title: document.title,
    });
  }
}

export default {
  track,
  trackCustomEvent,
  trackPageView,
};
